/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { useFormikContext } from 'formik';
import type { PaymentFormValues } from 'Src/types/payment';
import { PaymentFormikInput } from 'Components/widgets/payment-info/paymentFormik';
import { handleClickPaymentProviderBlock } from './paymentProvidersUtils';
type Props = {
  isDisabled: boolean;
  orderedPaymentProviders: ReadonlyArray<PaymentProvider>;
};
export const PaymentProvidersOldImplementation = ({
  isDisabled,
  orderedPaymentProviders,
}: Props) => {
  const formik = useFormikContext<PaymentFormValues>();
  return orderedPaymentProviders.map((paymentProvider) => (
    <div
      className="flex w-full cursor-pointer items-center border-0 border-t-1 border-solid border-lightGrey p-10 md:w-1/2 md:flex-col md:border-r-1"
      data-testid={`PaymentProviders-${paymentProvider.id}`}
      key={paymentProvider.id}
      onClick={() =>
        handleClickPaymentProviderBlock({
          paymentProvider,
          formik,
          isDisabled,
        })
      }
    >
      <input name="paymentProviderId" type="hidden" value={paymentProvider.id} />
      <div className="shrink-0">
        <PaymentFormikInput
          isDisabled={isDisabled}
          name="selectorPaymentProviderId"
          type="radio"
          value={paymentProvider.selectorId}
        />
      </div>
      <div className="gap-1à flex flex-1 items-center md:order-first md:flex-col">
        {paymentProvider.logo && (
          <img alt={paymentProvider.label} className="w-90" src={paymentProvider.logo} />
        )}
        {paymentProvider.description}
      </div>
    </div>
  ));
};
